/* istanbul ignore file */
export { default } from './HelpBox';
